
export default {
  name: 'PrivacyPolicy',
  layout: 'default',
  head() {
    return {
      title: 'XPPen Privacy Policy',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'XPPen Privacy Policy — how we collect, use, store, share and protect your personal information.',
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'XPPen, Privacy Policy, Personal Data',
        },
      ],
    }
  },
  mounted() {
    if (!process.client) return
    // App WebView: hide site chrome when opened from /app/
    try {
      const header = document.querySelector('header')
      const footer = document.querySelector('footer')
      if (header) header.style.display = 'none'
      if (footer) footer.style.display = 'none'
    } catch (e) {}
  },
}
